import React, {Component} from "react";
import { observer } from "mobx-react";
import OrderMenuLeftItemView from "./List/menu/OrderMenuLeftItemView";
import {fn_currMenuGroupList} from "../../../function/FnBodyMenu";
import OrderMenuLeftPagingBottomView from "./OrderMenuLeftPagingBottomView";
import {fn_commonLeftPageSet, fn_commonPageSet} from "../../../function/FnPage";

@observer
class OrderMenuLeftView extends Component {

    render() {
        const { rootStore } = this.props;
        const getMenuData = rootStore.menuStore.getMenuData;

        let pageStore = rootStore.pageStore.getLeftPagingInfo;

        let sliceLeftList = [];
        const totalPage = Math.ceil(getMenuData.length / 8);

        if( pageStore.max_page != totalPage )
            fn_commonLeftPageSet(rootStore, totalPage);
        sliceLeftList = ( totalPage > 1 )?getMenuData.slice((pageStore.page_no - 1) * 8, pageStore.page_no * 8):getMenuData;

        return (
            <div className="section_menu">
                <h2>상품 품절 관리</h2>
                <ul className="list_menu">
                    {(Array.isArray(sliceLeftList) && sliceLeftList.length > 0)
                    ?
                        sliceLeftList.map((obj, index)=>(
                        <OrderMenuLeftItemView key={"soldMenu"+index} rootStore={rootStore} obj={obj} />
                        )):null
                    }
                </ul>
                <OrderMenuLeftPagingBottomView rootStore={rootStore} />
            </div>
        );
    }
}

export default OrderMenuLeftView;